import { ROUTE_PATHS } from "./route-paths"
import { canViewDashboard } from "../utils/dashboard-access"

export const MASTER_SCOPES = Object.freeze({
    DASHBOARD: "dashboard",
    COMMON: "common",
    CUSTOMERS: "customers",
    ACCOUNTING: "accounting",
    CATALOG: "catalog",
    LOCATIONS: "locations",
    CASH: "cash",
})

const routeMasterRules = [
    {
        prefixes: [ROUTE_PATHS.DASHBOARD],
        scopes: [MASTER_SCOPES.DASHBOARD],
    },
    {
        prefixes: [ROUTE_PATHS.DASHBOARD_SALES_REVENUE, ROUTE_PATHS.DASHBOARD_INVENTORY_OPERATIONS, ROUTE_PATHS.DASHBOARD_PRODUCT_CATEGORY, ROUTE_PATHS.DASHBOARD_COMPLIANCE_DATA_QUALITY, ROUTE_PATHS.DASHBOARD_CUSTOMER_LOYALTY, ROUTE_PATHS.DASHBOARD_FINANCE_MANAGEMENT],
        scopes: [MASTER_SCOPES.LOCATIONS],
    },
    {
        prefixes: ["/customers", "/customer-import", "/customer-create", "/customer-edit", "/customer-groups", "/customer-loyalty"],
        scopes: [MASTER_SCOPES.CUSTOMERS, MASTER_SCOPES.LOCATIONS],
    },
    {
        prefixes: [ROUTE_PATHS.PRODUCTS, "/item-groups", "/terpenes", "/suppliers", "/print-labels"],
        scopes: [MASTER_SCOPES.CATALOG, MASTER_SCOPES.LOCATIONS],
    },
    {
        prefixes: ["/inventory-manager", "/inventory-adjustments", "/stock", "/stock-logs", "/stock-import", "/cova-import", "/cova-reconciliation", "/import-history", "/stock-transfers"],
        scopes: [MASTER_SCOPES.CATALOG, MASTER_SCOPES.LOCATIONS],
    },
    {
        prefixes: ["/purchase-orders"],
        scopes: [MASTER_SCOPES.CATALOG, MASTER_SCOPES.LOCATIONS],
    },
    {
        prefixes: ["/orders", "/sales", "/invoices"],
        scopes: [MASTER_SCOPES.LOCATIONS],
    },
    {
        prefixes: ["/promotions"],
        scopes: [MASTER_SCOPES.CUSTOMERS, MASTER_SCOPES.CATALOG, MASTER_SCOPES.LOCATIONS],
    },
    {
        prefixes: ["/reports"],
        scopes: [
            MASTER_SCOPES.COMMON,
            MASTER_SCOPES.LOCATIONS,
            MASTER_SCOPES.CATALOG,
            MASTER_SCOPES.CUSTOMERS,
            MASTER_SCOPES.ACCOUNTING,
            MASTER_SCOPES.CASH,
        ],
    },
    {
        prefixes: ["/cash-management", "/safe-drawers", "/safe-drawer-transactions"],
        scopes: [MASTER_SCOPES.CASH, MASTER_SCOPES.LOCATIONS, MASTER_SCOPES.ACCOUNTING],
    },
    {
        prefixes: [
            "/settings",
            "/gl-accounts",
            "/gl-defaults",
            "/mode-of-payments",
            "/payment-hardware",
            "/payment-hardware-create",
            "/payment-hardware-edit",
            "/reason-codes",
            "/devices",
            "/pos-app-releases",
            "/agco-reporting",
        ],
        scopes: [MASTER_SCOPES.COMMON, MASTER_SCOPES.ACCOUNTING, MASTER_SCOPES.LOCATIONS, MASTER_SCOPES.CASH],
    },
    {
        prefixes: ["/inventory-counts"],
        scopes: [MASTER_SCOPES.LOCATIONS],
    },
    {
        prefixes: ["/agco-logs", "/reconciliations"],
        scopes: [MASTER_SCOPES.CATALOG, MASTER_SCOPES.LOCATIONS],
    },
]

function matchesPrefix(path, prefix) {
    return path === prefix || path.startsWith(`${prefix}/`)
}

export function masterScopesForRoute(path, user) {
    const scopes = routeMasterRules
        .filter((rule) => rule.prefixes.some((prefix) => matchesPrefix(path, prefix)))
        .flatMap((rule) => rule.scopes)

    return [...new Set(scopes)].filter((scope) => scope !== MASTER_SCOPES.DASHBOARD || canViewDashboard(user))
}
